
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
//Pages
import { AtividadePage } from '../atividade/atividade';
import { PalestrantePerfilPage } from '../palestrante-perfil/palestrante-perfil';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
import { CustomSearchbar } from '../../components/custom-searchbar/custom-searchbar';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { SearchProvider } from '../../providers/search-provider';
//Models
import { Congresso } from '../../models/congresso.model';
import { User } from '../../models/user.model';
import { DayProgram } from '../../models/day-program.model';
import { SearchModel } from '../../models/search.model';
import { Lecturer } from '../../models/lecturer.model';
import { Activity } from '../../models/activity.model';
import { Area } from './../../models/area.model';
import { AreaProgram } from './../../models/area.program.model';
import { Expositor } from '../../models/expositor/expositor.model';
import { ExpositorPage } from '../expositor/expositor';
import { ExpositoresPorTipo } from '../../models/expositor/expositores-tipo.model';

@Component({
    selector: 'page-busca',
    templateUrl: 'busca.html'
})
export class BuscaPage {
    @ViewChild(CustomSearchbar) searchbar: CustomSearchbar;

    public program: SearchModel = new SearchModel();
    public atividadesDia: DayProgram[];
    public atividadesArea: AreaProgram[];
    public palestrantes: Lecturer[];
    public expositores: Expositor[];
    public user: User;
    public congresso: Congresso;
    public isCurrent: boolean;
    public filterSelected: undefined;

    public days: string;
    public palestrantesCount: number = 0;
    public atividadesCount: number = 0;
    public expositoresCount: number = 0;

    public self = this;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        private configProvider: ConfigProvider,
        private searchProvider: SearchProvider,
        public utilProvider: UtilProvider,
        private app: App) {
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL || this.congresso.Liberado;
    }

    ionViewDidEnter() {
        this.initialize();
    }

    initialize() {
        if (this.utilProvider.searchTerm == "") this.navCtrl.pop();
        this.atividadesDia = localStorage.getItem('atividadesDia') ? JSON.parse(localStorage.getItem('atividadesDia')) as DayProgram[] : null;
        this.atividadesArea = localStorage.getItem('atividadesArea') ? JSON.parse(localStorage.getItem('atividadesArea')) as AreaProgram[] : null;
        this.palestrantes = localStorage.getItem('palestrantes') ? JSON.parse(localStorage.getItem('palestrantes')) as Lecturer[] : null;
        let expositoresPorTipo = localStorage.getItem('expositores') ? JSON.parse(localStorage.getItem('expositores')) as ExpositoresPorTipo[] : null;
        this.expositores = new Array<Expositor>();
        
        if (expositoresPorTipo) {
            expositoresPorTipo.forEach(g => {
                g.Expositores.forEach(e => {
                    this.expositores.push(e);
                })
            })
        }

        var term = this.utilProvider.prepareSearch(this.utilProvider.searchTerm);

        this.searchPalestrantesByTerm(term, this.palestrantes);
        this.searchExpositoresByTerm(term, this.expositores);
        this.searchAtividadesByTerm(term, this.atividadesDia);
        this.searchAtividadesAreaByTerm(term, this.atividadesArea);

        /*var self = this;
        setTimeout(function() {
            self.searchbar.setFocus();
        },150)*/
        this.utilProvider.searchInFocus = false;
    }

    searchPalestrantesByTerm(term: string, palestrantes: Lecturer[]) {
        if (palestrantes.length != 0) {
            this.program.Palestrantes = [];
            this.palestrantesCount = 0;
            palestrantes.forEach(palestrante => {
                if (this.utilProvider.prepareSearch(palestrante.Nome).includes(term) ||
                    this.utilProvider.prepareSearch(palestrante.Estado).includes(term) ||
                    this.utilProvider.prepareSearch(palestrante.Cidade).includes(term)) {
                    this.program.Palestrantes.push(palestrante);
                    this.palestrantesCount++;
                }
            });
        }
    }

    searchAtividadesByTerm(term: string, atividadesDia: Array<DayProgram>) {
        if (atividadesDia.length != 0) {
            this.atividadesCount = 0;
            atividadesDia.forEach((dia, index) => {
                this.program.AtividadesDia[index] = new DayProgram();
                this.program.AtividadesDia[index].Atividades = [];
                dia.Atividades.forEach(atividade => {
                    if (this.utilProvider.prepareSearch(atividade.TemaDaAtividade).includes(term) ||
                        this.utilProvider.prepareSearch(atividade.HoraInicioAtividade).includes(term) ||
                        this.utilProvider.prepareSearch(atividade.SiglaSala).includes(term) ||
                        this.utilProvider.prepareSearch(atividade.DescritivoSala).includes(term) ||
                        this.utilProvider.prepareSearch(atividade.Sigla).includes(term)) {
                        this.program.AtividadesDia[index].Atividades.push(atividade);
                        this.atividadesCount++;
                    }
                });
                this.program.AtividadesDia[index].Dia = dia.Dia;
            });
        }
    }

    searchAtividadesAreaByTerm(term: string, atividadesArea: Array<AreaProgram>) {

        if (atividadesArea.length != 0) {
            this.atividadesCount = 0;
            atividadesArea.forEach((area, index) => {
                this.program.AtividadesArea[index] = new AreaProgram();
                this.program.AtividadesArea[index].Atividades = [];
                area.Atividades.forEach(atividade => {
                    if (this.utilProvider.prepareSearch(atividade.TemaDaAtividade).includes(term) ||
                        this.utilProvider.prepareSearch(atividade.Duracao).includes(term)) {
                        this.program.AtividadesArea[index].Atividades.push(atividade);
                        this.atividadesCount++;
                    }
                });
                this.program.AtividadesArea[index].Area = area.Area;
            });
        }
    }
    searchExpositoresByTerm(term: string, expositores: Expositor[]) {
        if (expositores.length != 0) {
            this.program.Expositores = [];
            this.expositoresCount = 0;
            expositores.forEach(expositor => {
                if (this.utilProvider.prepareSearch(expositor.Nome).includes(term)) {
                    this.program.Expositores.push(expositor);
                    this.expositoresCount++;
                }
            });
        }
    }
    sendToPalestrantes(palestrante: any) {
        this.navCtrl.push(PalestrantePerfilPage, {
            palestrante: palestrante,
        });
    }

    sendToExpositor(expositor: any) {
        this.navCtrl.push(ExpositorPage, {
            expositor: expositor,
        });
    }

    openInscriptionPage(activity: Activity) {
        this.navCtrl.push(AtividadePage, {
            id: activity.AtividadeId,
            activity: activity
        });
    }

    hasResult() {
        return this.palestrantesCount + this.atividadesCount + this.expositoresCount != 0;
    }

    hasData() {
        return this.palestrantes || this.atividadesDia || this.expositores;
    }

    platformIsIos() {
        return this.utilProvider.getPlatform() == 'ios';
    }

    back() {
        this.navCtrl.pop();
    }

    hasActivities() {
        if (this.program.AtividadesDia.length) {
            return this.program.AtividadesDia[0].Atividades.length == 0 &&
                this.program.AtividadesDia[1].Atividades.length == 0 &&
                this.program.AtividadesDia[2].Atividades.length == 0
        }
        else {
            return this.program.AtividadesArea[0].Atividades.length == 0 &&
                this.program.AtividadesArea[1].Atividades.length == 0 &&
                this.program.AtividadesArea[2].Atividades.length == 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/busca/busca.ts